import {apiOption, apiResponse, only} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'Actradis'
export const PROVIDER_LOADED = NAMESPACE + '/ProviderLoaded'
export const PROVIDER_RESET = NAMESPACE + '/ProviderReset'

export function loadProvider(siretNumber) {
    return loading(fetch(config.api.url + '/actradis/providercompanies/' + siretNumber, apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: PROVIDER_LOADED,
            provider: json
        }
    }).catch(only(404, (error) => {
        return {
            type: PROVIDER_LOADED,
            provider: null
        }
    })), PROVIDER_LOADED)
}

export function resetProvider() {
    return {
        type: PROVIDER_RESET
    }
}


// WEBPACK FOOTER //
// ./lib/actradis/actions.js